export const getSignInPageUrl = (redirect?: string): string =>
  `/sign-in${typeof redirect === 'string' ? `?redirect=${redirect}` : ''}`;
